import React, { createContext, forwardRef, useContext, type ReactNode } from 'react';
import { Platform, StyleSheet, Text as TexteRN, type TextProps } from 'react-native';
import { interfaceRtl } from '../i18n/sens';

/**
 * LE TEXTE DE L'APPLICATION — celui de React Native, avec une direction de paragraphe FORCÉE en arabe
 * sur iOS. Toute l'app l'importe à la place de `Text` (décision du 17/10/2026).
 *
 * Sans `writingDirection`, iOS prend la direction de base dans la LANGUE DU TÉLÉPHONE
 * (`defaultWritingDirectionForLanguage:nil`, RCTAttributedTextUtils.mm) : une interface arabe sur un
 * iPhone en français avait des paragraphes de gauche à droite, le point final du mauvais côté.
 * Android n'a pas cette propriété : il reçoit une marque RLM au début des chaînes arabes (`t`, i18n).
 * Le web passe par la feuille de style de `i18n/sens.ts`.
 *
 * Un style explicite gagne (le défaut passe en premier), et les blocs gardés de gauche à droite —
 * CV, lettres, aperçus, texte des offres — désactivent le forçage par `SensTexteLtr`.
 */
const SensTexte = createContext<'auto' | 'ltr'>('auto');

export function SensTexteLtr({ children }: { children: ReactNode }) {
  return <SensTexte.Provider value="ltr">{children}</SensTexte.Provider>;
}

export const Text = forwardRef<React.ElementRef<typeof TexteRN>, TextProps>(function Text({ style, ...props }, ref) {
  const sens = useContext(SensTexte);
  const rtl = Platform.OS === 'ios' && sens !== 'ltr' && interfaceRtl();
  return <TexteRN ref={ref} {...props} style={rtl ? [styles.rtl, style] : style} />;
});

const styles = StyleSheet.create({ rtl: { writingDirection: 'rtl' } });
